<template>
  <div class="download-component">
    <a href="javascript:;" class="download-button">
      <slot
        ><span
          @click="showDownloadOptions"
          class="iconfont icon-downloadFile"
        ></span
      ></slot>
    </a>

    <!-- 下载选项弹窗 -->
    <div
      class="weui-half-screen-dialog"
      :class="{ 'weui-half-screen-dialog_show': showDownloadDialog }"
      v-if="showDownloadDialog"
    >
      <div class="weui-half-screen-dialog__hd">
        <div class="weui-half-screen-dialog__hd__side">
          <button class="weui-icon-btn" @click="closeDialog">
            <i class="weui-icon-close-thin"></i>
          </button>
        </div>
        <div class="weui-half-screen-dialog__hd__main">
          <strong class="weui-half-screen-dialog__title">选择下载格式</strong>
        </div>
      </div>
      <div class="weui-half-screen-dialog__bd">
        <div class="download-options">
          <div
            class="download-option"
            v-for="option in downloadOptions"
            :key="option.type"
            @click="downloadDocument(option.type)"
          >
            <div class="option-icon">
              <i :class="option.icon"></i>
            </div>
            <div class="option-text">{{ option.label }}</div>
          </div>
        </div>
      </div>
    </div>

    <!-- 遮罩层 -->
    <div
      class="weui-mask"
      :class="{ 'weui-mask_active': showDownloadDialog }"
      v-if="showDownloadDialog"
      @click="closeDialog"
    ></div>
  </div>
</template>

<script>
import { getBaseUrl } from "@/util/env";
export default {
  name: "DownloadButton",
  props: {
    // 业务数据，包含bizId等信息
    caller: {
      type: String,
    },
    id: {
      type: Number,
    },
    // 下载接口的基础URL
    baseUrl: {
      type: String,
      default: "/api/print",
    },
    // 可用的下载格式
    formats: {
      type: Array,
      default: () => ["pdf", "word", "excel"],
    },
  },
  data() {
    return {
      showDownloadDialog: false,
      downloadOptions: [
        { type: "pdf", label: "PDF文档", icon: "iconfont icon-pdf" },
        { type: "word", label: "Word文档", icon: "iconfont icon-word" },
        { type: "excel", label: "Excel表格", icon: "iconfont icon-excel" },
      ],
    };
  },
  methods: {
    /**
     * 显示下载选项
     */
    showDownloadOptions() {
      if (!this.caller || !this.id) {
        this.$weui.topTips("缺少业务数据，无法下载", 3000);
        return;
      }
      this.showDownloadDialog = true;
    },

    /**
     * 关闭下载对话框
     */
    closeDialog() {
      this.showDownloadDialog = false;
    },

    downdocument(format) {
      // 构造下载参数
      const params = {
        bizType: this.caller,
        bizId: this.id,
      };

      // 调用下载接口
      this.$loading({
        url: this.baseUrl + "/" + format,
        params: params,
        responseType: "blob",
      })
        .then((response) => {
          this.handleDownloadResponse(response, format);
          this.closeDialog();
        })
        .catch((error) => {
          console.error("下载出错:", error);
          this.$weui.topTips("下载失败，请重试", 3000);
        });
    },
    handleDownloadResponse(response, format) {
      try {
        // 获取文件名
        let filename = this.caller || "document";
        const timestamp = new Date().getTime();

        // 根据格式设置文件扩展名
        const extensions = {
          pdf: ".pdf",
          word: ".docx",
          excel: ".xlsx",
        };

        filename = filename + "_" + timestamp + (extensions[format] || "");

        // 创建下载链接
        const url = window.URL.createObjectURL(new Blob([response]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", filename);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);

        this.$weui.toast("下载成功");
      } catch (error) {
        console.error("处理下载文件出错:", error);
        this.$weui.topTips("下载文件处理失败", 3000);
      }
    },

    downloadDocument(docType) {
      let me = this;
      // 根据格式过滤可用选项
      if (!me.formats.includes(docType)) {
        me.$weui.topTips(`不支持${docType}格式下载`, 3000);
        return;
      }
      const extensions = {
          pdf: ".pdf",
          word: ".docx",
          excel: ".xlsx",
        };
      if (window.uni) {
        /**
         * uniapp环境，文件下载问题
         */
        window.uni.webView.postMessage({
          data: {
            action: "downloadFile",
            params: {
              outUrl: getBaseUrl() + "/api/print/download/" + me.caller +'/'+
                me.id  + extensions[docType],
              type: "DOC",
            },
          },
        });
      } else {
        me.downdocument(docType);
      }
    },
  },
};
</script>

<style scoped>
.download-button {
  color: var(--weui-FG-1);
  display: flex;
  width: 100%;
  flex-direction: row-reverse;
  background-color: #fff;
}

.weui-half-screen-dialog {
  transform: translateY(100%);
  transition: transform 0.3s;
}

.weui-half-screen-dialog_show {
  transform: translateY(0);
}

.download-options {
  display: flex;
  justify-content: space-around;
  padding: 20px 0;
}

.download-option {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 15px;
  border-radius: 8px;
  transition: background-color 0.3s;
}

.download-option:hover {
  background-color: #f0f0f0;
}

.option-icon {
  font-size: 24px;
  margin-bottom: 10px;
}

.option-icon .iconfont {
  font-size: 36px;
}

.option-text {
  font-size: 14px;
  color: #333;
}
.icon-downloadFile {
  font-size: 18px;
  margin: 0px 10px;
}
.icon-pdf {
  color: #a12b3a;
}

.icon-word {
  color: #2b569a;
}

.icon-excel {
  color: #008000;
}

.weui-mask {
  opacity: 0;
  transition: opacity 0.3s;
}

.weui-mask_active {
  opacity: 1;
}
</style>